import React, { Component } from 'react';

class PrivacyPolicy extends Component {
  render() {
    return (
      <div className="row wrapper">
        <div className="small-12 columns ">
        <div className="box_border_video1">
        <div className="title_31">FITT-BD Privacy Policy</div>

        <div className="content11">
          <p>
            <b>Effective date: June 2026</b>
          </p>

          <p>
            This Privacy Policy applies to the FITT-BD patient portal website
            and mobile applications available on iOS and Android devices.
          </p>

          <p>
            The Focused Integrated Team-based Treatment Program for Bipolar
            Disorder (FITT-BD) is a program of the Massachusetts General
            Hospital Dauten Family Center for Bipolar Treatment Innovation.
          </p>

          <p>
            FITT-BD is committed to protecting the privacy and security of
            patient information. The collection, use, disclosure, and
            protection of personal and health information through FITT-BD are
            governed by applicable Mass General Brigham policies and practices.
          </p>

          <p className="title_policy1">Mass General Brigham Privacy Practices</p>

          <p>
            The privacy practices that apply to FITT-BD are described in the
            Mass General Brigham Notice of Privacy Practices and related Mass
            General Brigham privacy policies.
          </p>

          <p>Please review the following resources:</p>

          <p className="title_policy1">Mass General Brigham Notice of Privacy Practices</p>
          <p>
            <a
              href="https://www.massgeneralbrigham.org/en/notices/hipaa"
              target="_blank" rel="noopener noreferrer" >
              https://www.massgeneralbrigham.org/en/notices/hipaa
            </a>
          </p>

          <p className="title_policy1">Patient Gateway Privacy Policy</p>
          <p>
            <a
              href="https://patientgateway.massgeneralbrigham.org/mychart-prd/Authentication/Login?mode=stdfile&option=hlthprivacy"
              target="_blank" rel="noopener noreferrer" >
              Patient Gateway Privacy Policy
            </a>
          </p>

          <p className="title_policy1">Mass General Brigham Privacy Policy</p>
          <p>
            <a href="https://www.massgeneralbrigham.org/en/notices/web-privacy-policy"
              target="_blank" rel="noopener noreferrer" >
              https://www.massgeneralbrigham.org/en/notices/web-privacy-policy
            </a>
          </p>

          <p className="title_policy1">Mobile Application</p>

          <p>
            The FITT-BD mobile application provides secure access to the
            FITT-BD patient portal for authorized users through iOS and Android
            devices.
          </p>

          <p>
            Information accessed through the mobile application is subject to
            applicable Mass General Brigham privacy policies and practices,
            including the Mass General Brigham Notice of Privacy Practices.
          </p>

          <p className="title_policy1">Security</p>

          <p>
            Mass General Brigham employs administrative, technical, and
            physical safeguards designed to protect personal and health
            information from unauthorized access, use, or disclosure.
          </p>

          <p className="title_policy1">Contact Information</p>

          <p>
            Dauten Family Center for Bipolar Treatment Innovation
            <br />
            50 Staniford Street, Suite 580
            <br />
            Boston, MA 02114
          </p>

          <p>
            Email:{' '}
            <a href="mailto:fitt-bd@mgh.harvard.edu">
              fitt-bd@mgh.harvard.edu
            </a>
          </p>

          <p className="title_policy1">Questions</p>

          <p>
            If you have questions regarding FITT-BD or the privacy practices
            described above, please contact the FITT-BD team or review the Mass
            General Brigham privacy resources listed on this page.
          </p>
        </div>
        </div>
      </div>
    </div>
    );
  }
}

export default PrivacyPolicy;
